function updateTrackingConsent() {
  const groups = window.OnetrustActiveGroups || '';

  const trackingConsent = groups.includes('C0002')
    ? 'granted'
    : 'declined';

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        tracking_consent: trackingConsent
      }
    })
  })
  .then(() => {
    console.log('Tracking consent updated:', trackingConsent);
  })
  .catch(console.error);
}

// Initial load
updateTrackingConsent();

window.addEventListener('OneTrustGroupsUpdated', function () {
  updateTrackingConsent();
});